__turbopack_context__.v({
  "gradientRing": "ChatInput-module-scss-module__JPav_q__gradientRing",
});
